import {useTranslation} from "react-i18next";
import {Language} from "../../app/types";
import FormFieldBox from "../../common/form/FormFieldBox";
import TextInput from "../../common/form/TextInput";
import FormRow from "../../common/form/FormRow";
import React, {useMemo} from "react";
import {Control} from "react-hook-form";

type Props = {
    index: number
    control: Control<any>
}


export const LanguageForm = ({ index, control }: Props) => {
    const { t } = useTranslation()

    const languageOptions = useMemo(
        () =>
            Object.values(Language).map(language => {
                return {
                    value: language,
                    label: t(`users.language.${language}`),
                }
            }),
        [t]
    )

    return (<FormRow>
        <FormFieldBox>
            <TextInput readonly={false} label={t('users.edit.language')} name={`fieldUpdates.${index}.values.0.stringValue`} control={control} required={true} options={languageOptions} />
        </FormFieldBox>
    </FormRow>)
}